"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModal = exports.StyledConversationalSearchWrapper = exports.StyledConversationalResultsView = exports.COLOR_AI_PURPLE = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _core = require("@linaria/core");
"c1rusfhe";
const intents = new _intents.default();
const COLOR_AI_PURPLE = exports.COLOR_AI_PURPLE = '#744BC4';
function paddingCalculation({
  isMobile,
  isModal
}) {
  if (isMobile) {
    return isModal ? 8 : 0;
  }
  return 24;
}
const StyledConversationalSearchWrapper = exports.StyledConversationalSearchWrapper = /*#__PURE__*/(0, _react.styled)("div")({
  name: "StyledConversationalSearchWrapper",
  class: "svjypiq",
  vars: {
    "svjypiq-0": [({
      styling,
      isDesktop
    }) => isDesktop ? styling?.width || '900px' : '94vw'],
    "svjypiq-1": [({
      isMobile
    }) => isMobile ? 85 : 90, "vh"],
    "svjypiq-2": [({
      isMobile
    }) => isMobile ? '85vh - 68px' : '90vh - 84px'],
    "svjypiq-3": [({
      isMobile
    }) => isMobile ? 68 : 84, "px"],
    "svjypiq-7": [({
      isMobile
    }) => isMobile ? 8 : 16, "px"],
    "svjypiq-9": [({
      isMobile
    }) => isMobile ? 48 : 64, "px"],
    "svjypiq-12": [({
      isMobile
    }) => isMobile ? 16 : 20, "px"],
    "svjypiq-13": [({
      isDesktop
    }) => isDesktop ? 6 : 4, "vh"],
    "svjypiq-18": [({
      isMobile
    }) => isMobile ? 32 : 48, "px"],
    "svjypiq-19": [({
      isDesktop
    }) => isDesktop ? 25 : 20, "vh"],
    "svjypiq-21": [({
      isDesktop
    }) => isDesktop ? 20 : 30, "%"],
    "svjypiq-22": [({
      isModal
    }) => isModal ? 20 : 13, "%"],
    "svjypiq-23": [({
      isMobile
    }) => isMobile ? 15 : 20, "px"],
    "svjypiq-25": [({
      isMobile
    }) => isMobile ? 'none' : 'initial'],
    "svjypiq-26": [({
      isMobile
    }) => isMobile ? 0 : 115, "px"],
    "svjypiq-28": [({
      isMobile,
      isModal
    }) => paddingCalculation({
      isMobile,
      isModal
    }), "px"]
  }
});
const StyledModal = exports.StyledModal = /*#__PURE__*/(0, _react.styled)(_modal.default)({
  name: "StyledModal",
  class: "s1hjlted"
});
const StyledConversationalResultsView = exports.StyledConversationalResultsView = /*#__PURE__*/(0, _react.styled)("div")({
  name: "StyledConversationalResultsView",
  class: "s1axmvod",
  vars: {
    "s1axmvod-0": [({
      isMobile,
      showResultsHeading,
      showExactMatchBlock,
      isModal
    }) => {
      if (isModal) {
        const heading = showResultsHeading || showExactMatchBlock ? 44 : 10;
        return isMobile ? heading : 56;
      }
      return 0;
    }, "px"],
    "s1axmvod-5": [({
      isMobile
    }) => isMobile ? 100 : 50, "%"]
  }
});